'use client';

import { selectAuthUser } from '@/features/auth';
import { selectCurrentEscritorio } from '@/features/escritorio';
import { useMessagingRealtime } from '@/features/messaging';
import { useAppSelector } from '@/store/hooks';

/**
 * A página do certificado fica fora do detalhe da negociação, que é quem liga o tempo real. Sem
 * ele, nenhum acontecimento do caso chega ao store e a consulta aberta não se atualiza (ACC-01).
 * A aba não usa este hook: dentro do detalhe, um segundo stream duplicaria cada evento.
 */
export function useTempoRealDoCertificado() {
  const usuario = useAppSelector(selectAuthUser);
  const escritorio = useAppSelector(selectCurrentEscritorio);
  useMessagingRealtime(usuario?.empresaId ?? "", escritorio?.id);
}